import { Button, Typography } from "@carrotfertility/carotene-core"
import React from "react"

export function BookedPage({ onBackToHome }: { onBackToHome?: () => void }): JSX.Element {
  return (
    <>
      <Typography>This is the Booked page</Typography>
      <Button onClick={onBackToHome}>Back to home</Button>
    </>
  )
}
